import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import FeaturesSection from './components/FeaturesSection';
import ApplicationsSection from './components/ApplicationsSection';
import StatsSection from './components/StatsSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  useEffect(() => {
    // Remove existing schema scripts to prevent duplicates
    const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
    existingSchemas.forEach(script => script.remove());

    // Add Organization Schema
    const organizationSchema = document.createElement('script');
    organizationSchema.type = 'application/ld+json';
    organizationSchema.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Aircraft Shelter Solutions",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "logo": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/vite.svg`,
      "description": "Professional hardened aircraft shelter arch panels for military and aviation facilities. Durable, weather-resistant construction solutions for aircraft protection and hangar infrastructure.",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+82-2-2247-1900",
        "email": "hanbum@hanbum.co.kr",
        "contactType": "Customer Service",
        "availableLanguage": ["English", "Korean"]
      },
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "KR"
      },
      "foundingDate": "2000",
      "numberOfEmployees": "50-100",
      "industry": "Military Aviation Infrastructure",
      "sameAs": []
    });
    document.head.appendChild(organizationSchema);

    // Add WebPage Schema
    const webPageSchema = document.createElement('script');
    webPageSchema.type = 'application/ld+json';
    webPageSchema.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Aircraft Shelter Arch Panels | Hardened Military Aviation Infrastructure",
      "description": "Professional hardened aircraft shelter arch panels for military and aviation facilities. Durable, weather-resistant construction solutions for aircraft protection and hangar infrastructure with superior engineering.",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "inLanguage": "en",
      "isPartOf": {
        "@type": "WebSite",
        "name": "Aircraft Shelter Solutions",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com"
      },
      "about": {
        "@type": "Thing",
        "name": "Aircraft Shelter Construction",
        "description": "Military aviation infrastructure and aircraft protection solutions"
      }
    });
    document.head.appendChild(webPageSchema);

    // Add Product Schema
    const productSchema = document.createElement('script');
    productSchema.type = 'application/ld+json';
    productSchema.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Aircraft Shelter Arch Panels",
      "description": "Hardened military aviation infrastructure solutions including arch panels for aircraft shelters and hangar construction. Weather-resistant, durable construction materials designed for military specifications.",
      "category": "Military Aviation Infrastructure",
      "brand": {
        "@type": "Brand",
        "name": "Aircraft Shelter Solutions"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "Aircraft Shelter Solutions",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com"
      },
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "USD",
        "seller": {
          "@type": "Organization",
          "name": "Aircraft Shelter Solutions"
        }
      },
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "Material",
          "value": "Hardened Steel and Composite Materials"
        },
        {
          "@type": "PropertyValue",
          "name": "Application",
          "value": "Military Aircraft Shelters and Hangars"
        },
        {
          "@type": "PropertyValue",
          "name": "Certification",
          "value": "Military Specification Compliant"
        }
      ]
    });
    document.head.appendChild(productSchema);

    // Cleanup function to remove scripts when component unmounts
    return () => {
      const schemas = document.querySelectorAll('script[type="application/ld+json"]');
      schemas.forEach(script => script.remove());
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <ProductsSection />
        <FeaturesSection />
        <ApplicationsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
